module.exports = __webpack_public_path__ + "img/item9.3d14fe20.png";